var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXTwitterFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57143 3C4.15313 3 3 4.15313 3 5.57143V18.4286C3 19.8469 4.15313 21 5.57143 21H18.4286C19.8469 21 21 19.8469 21 18.4286V5.57143C21 4.15313 19.8469 3 18.4286 3H5.57143ZM17.5085 6.375L13.3379 11.1402L18.2437 17.625H14.4027L11.3973 13.6915L7.95402 17.625H6.04554L10.5054 12.5263L5.80045 6.375H9.73795L12.458 9.97098L15.6 6.375H17.5085ZM15.9897 16.4839L9.16339 7.4558H8.02634L14.929 16.4839H15.9857H15.9897Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitterFill);
export default __webpack_public_path__ + "static/media/x-twitter-fill.91c97dad4f9d8d026c265ef36ce75558.svg";
export { ForwardRef as ReactComponent };